import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ItemPickerOptionModel } from './models/item-picker-option.model';
import { ItemPickerModel } from './models/item-picker.model';

@Component({
	selector: 'app-item-picker',
	templateUrl: './item-picker.component.html',
	styleUrls: ['./item-picker.component.scss']
})
export class ItemPickerComponent {
	@Input() public input: ItemPickerModel;
	@Output() public itemSelected: EventEmitter<string[]> = new EventEmitter();

	public constructor() {}

	public onSelect(itemSelected: ItemPickerOptionModel) {
		if (!this.input.settings.allowMultiSelection) {
			this.input.options.forEach((item: ItemPickerOptionModel) => (item.isSelected = false));
		}

		itemSelected.isSelected = true;

		this.itemSelected.emit(
			this.input.options
				.filter((item: ItemPickerOptionModel) => item.isSelected)
				.map((item: ItemPickerOptionModel) => item.value)
		);
	}
}
